var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRevestimento(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.196,
    height: 46.633,
    viewBox: "0 0 58.196 46.633",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_982",
    "data-name": "Grupo 982",
    transform: "translate(-643.612 -617.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_976",
    "data-name": "Grupo 976",
    transform: "translate(651.271 617.648)",
    opacity: 0.346
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_457",
    "data-name": "Grupo 457",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_207",
    "data-name": "Caminho 207",
    d: "M2.262,25.578,14.62,32.713a4.523,4.523,0,0,1,1.656,6.179l-4.47,7.741H36.119a4.524,4.524,0,0,0,3.918-2.262l9.895-17.137a4.524,4.524,0,0,0-1.656-6.179L35.918,13.92a4.524,4.524,0,0,1-1.657-6.18L38.73,0H14.418A4.523,4.523,0,0,0,10.5,2.262L.606,19.4a4.524,4.524,0,0,0,1.656,6.179",
    transform: "translate(0)",
    fill: "#d9d9d8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_978",
    "data-name": "Grupo 978",
    transform: "translate(-326.208 129.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_977",
    "data-name": "Grupo 977"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_688",
    "data-name": "Ret\\xE2ngulo 688",
    width: 6.171,
    height: 6.171,
    transform: "translate(971.044 490.617)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_689",
    "data-name": "Ret\\xE2ngulo 689",
    width: 6.171,
    height: 6.171,
    transform: "translate(971.044 503.807)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_690",
    "data-name": "Ret\\xE2ngulo 690",
    width: 6.171,
    height: 6.171,
    transform: "translate(1004.19 503.807)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_691",
    "data-name": "Ret\\xE2ngulo 691",
    width: 13.106,
    height: 6.171,
    transform: "translate(977.417 503.807)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_692",
    "data-name": "Ret\\xE2ngulo 692",
    width: 13.106,
    height: 6.171,
    transform: "translate(990.702 503.807)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_693",
    "data-name": "Ret\\xE2ngulo 693",
    width: 6.171,
    height: 6.171,
    transform: "translate(971.044 516.998)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_694",
    "data-name": "Ret\\xE2ngulo 694",
    width: 6.171,
    height: 6.171,
    transform: "translate(1004.19 516.998)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_695",
    "data-name": "Ret\\xE2ngulo 695",
    width: 13.106,
    height: 6.171,
    transform: "translate(977.417 516.998)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_696",
    "data-name": "Ret\\xE2ngulo 696",
    width: 13.106,
    height: 6.171,
    transform: "translate(990.702 516.998)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_697",
    "data-name": "Ret\\xE2ngulo 697",
    width: 13.106,
    height: 6.171,
    transform: "translate(971.044 497.212)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_698",
    "data-name": "Ret\\xE2ngulo 698",
    width: 13.106,
    height: 6.171,
    transform: "translate(984.149 497.212)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_699",
    "data-name": "Ret\\xE2ngulo 699",
    width: 13.106,
    height: 6.171,
    transform: "translate(997.255 497.212)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_700",
    "data-name": "Ret\\xE2ngulo 700",
    width: 13.106,
    height: 6.171,
    transform: "translate(971.044 510.403)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_701",
    "data-name": "Ret\\xE2ngulo 701",
    width: 13.106,
    height: 6.171,
    transform: "translate(984.149 510.403)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_702",
    "data-name": "Ret\\xE2ngulo 702",
    width: 13.106,
    height: 6.171,
    transform: "translate(997.255 510.403)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_703",
    "data-name": "Ret\\xE2ngulo 703",
    width: 13.106,
    height: 6.171,
    transform: "translate(984.149 523.593)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6293",
    "data-name": "Caminho 6293",
    d: "M997.255,529.764v-6.171h13.106v6.171",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_704",
    "data-name": "Ret\\xE2ngulo 704",
    width: 13.106,
    height: 6.171,
    transform: "translate(971.044 523.593)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_705",
    "data-name": "Ret\\xE2ngulo 705",
    width: 13.106,
    height: 6.171,
    transform: "translate(977.214 490.617)",
    fill: "none",
    stroke: "#07233e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6294",
    "data-name": "Caminho 6294",
    d: "M1010.225,529.764v-8.426s-9.532-1.787-11.49-7.149-1.872-9.872-8.851-8.425-12.936,3.149-19.064-.6v24.6h33.19",
    fill: "#fff",
    stroke: "#48af77",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevestimento);
export default __webpack_public_path__ + "static/media/revestimento.b6e13636f4cafeb4d721307d92ac6a67.svg";
export { ForwardRef as ReactComponent };